module.exports = __webpack_public_path__ + "static/scale-model-of-cleveland-ohio-61202d7da1d85e2d6e61da569d7f9b24.png";